// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Objects.
// *********************************
import * as i from '../interfaces';
import { WordPressAddon, SiteSummary, SearchFilters, SortOptions, WordPressSite } from './site';
import * as e from '../enums';

export function enumStringToValue<E>(enumRef: any, value: string): E {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}

export class AppConfig implements i.AppConfigInterface {
  partnerId: string;
  showAdvancedFeatures: boolean;
  showIncludedTemplates: boolean;
  showBackupsFeatures: boolean;
  showDomainsFeatures: boolean;
  showImportFeatures: boolean;
  showStagingFeatures: boolean;

  static fromProto(proto: any): AppConfig {
    let m = new AppConfig();
    m = Object.assign(m, proto);
    return m;
  }

  constructor(kwargs?: i.AppConfigInterface) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }

  toApiJson(): object {
    const toReturn: {
      [key: string]: any;
    } = {};

    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.showAdvancedFeatures !== 'undefined') {
      toReturn['showAdvancedFeatures'] = this.showAdvancedFeatures;
    }
    if (typeof this.showIncludedTemplates !== 'undefined') {
      toReturn['showIncludedTemplates'] = this.showIncludedTemplates;
    }
    if (typeof this.showBackupsFeatures !== 'undefined') {
      toReturn['showBackupsFeatures'] = this.showBackupsFeatures;
    }
    if (typeof this.showDomainsFeatures !== 'undefined') {
      toReturn['showDomainsFeatures'] = this.showDomainsFeatures;
    }
    if (typeof this.showImportFeatures !== 'undefined') {
      toReturn['showImportFeatures'] = this.showImportFeatures;
    }
    if (typeof this.showStagingFeatures !== 'undefined') {
      toReturn['showStagingFeatures'] = this.showStagingFeatures;
    }
    return toReturn;
  }
}

export class BackfillRequest implements i.BackfillRequestInterface {
  pageSize: number;
  index: number;

  static fromProto(proto: any): BackfillRequest {
    let m = new BackfillRequest();
    m = Object.assign(m, proto);
    return m;
  }

  constructor(kwargs?: i.BackfillRequestInterface) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }

  toApiJson(): object {
    const toReturn: {
      [key: string]: any;
    } = {};

    if (typeof this.pageSize !== 'undefined') {
      toReturn['pageSize'] = this.pageSize;
    }
    if (typeof this.index !== 'undefined') {
      toReturn['index'] = this.index;
    }
    return toReturn;
  }
}

export class BackfillResponse implements i.BackfillResponseInterface {
  message: string;

  static fromProto(proto: any): BackfillResponse {
    let m = new BackfillResponse();
    m = Object.assign(m, proto);
    return m;
  }

  constructor(kwargs?: i.BackfillResponseInterface) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }

  toApiJson(): object {
    const toReturn: {
      [key: string]: any;
    } = {};

    if (typeof this.message !== 'undefined') {
      toReturn['message'] = this.message;
    }
    return toReturn;
  }
}

export class BootstrapSiteRequest implements i.BootstrapSiteRequestInterface {
  siteId: string;
  coreCurrentVersion: string;
  coreLatestVersion: string;
  plugins: WordPressAddon[];
  theme: WordPressAddon;

  static fromProto(proto: any): BootstrapSiteRequest {
    let m = new BootstrapSiteRequest();
    m = Object.assign(m, proto);
    if (proto.plugins) {
      m.plugins = proto.plugins.map(WordPressAddon.fromProto);
    }
    if (proto.theme) {
      m.theme = WordPressAddon.fromProto(proto.theme);
    }
    return m;
  }

  constructor(kwargs?: i.BootstrapSiteRequestInterface) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }

  toApiJson(): object {
    const toReturn: {
      [key: string]: any;
    } = {};

    if (typeof this.siteId !== 'undefined') {
      toReturn['siteId'] = this.siteId;
    }
    if (typeof this.coreCurrentVersion !== 'undefined') {
      toReturn['coreCurrentVersion'] = this.coreCurrentVersion;
    }
    if (typeof this.coreLatestVersion !== 'undefined') {
      toReturn['coreLatestVersion'] = this.coreLatestVersion;
    }
    if (typeof this.plugins !== 'undefined' && this.plugins !== null) {
      toReturn['plugins'] = 'toApiJson' in this.plugins ? (this.plugins as any).toApiJson() : this.plugins;
    }
    if (typeof this.theme !== 'undefined' && this.theme !== null) {
      toReturn['theme'] = 'toApiJson' in this.theme ? (this.theme as any).toApiJson() : this.theme;
    }
    return toReturn;
  }
}

export class DeleteSiteRequest implements i.DeleteSiteRequestInterface {
  siteIds: string[];

  static fromProto(proto: any): DeleteSiteRequest {
      let m = new DeleteSiteRequest();
      m = Object.assign(m, proto);
      return m;
  }

  constructor(kwargs?: i.DeleteSiteRequestInterface) {
      if (!kwargs) {
          return;
      }
      Object.assign(this, kwargs);
  }

  toApiJson(): object {
      const toReturn: {
          [key: string]: any;
      } = {};
      
      if (typeof this.siteIds !== 'undefined') {toReturn['siteIds'] = this.siteIds;}
      return toReturn;
  }
}

export class DeleteSitesResponse implements i.DeleteSitesResponseInterface {
  successfulSiteIds: string[];
  failedSiteIds: DeleteSitesResult[];
  status: string;
  totalProcessed: number;
  successCount: number;
  failureCount: number;

  static fromProto(proto: any): DeleteSitesResponse {
      let m = new DeleteSitesResponse();
      m = Object.assign(m, proto);
      if (proto.failedSiteIds) {m.failedSiteIds = proto.failedSiteIds.map(DeleteSitesResult.fromProto);}
      return m;
  }

  constructor(kwargs?: i.DeleteSitesResponseInterface) {
      if (!kwargs) {
          return;
      }
      Object.assign(this, kwargs);
  }

  toApiJson(): object {
      const toReturn: {
          [key: string]: any;
      } = {};
      
      if (typeof this.successfulSiteIds !== 'undefined') {toReturn['successfulSiteIds'] = this.successfulSiteIds;}
      if (typeof this.failedSiteIds !== 'undefined' && this.failedSiteIds !== null) {toReturn['failedSiteIds'] = 'toApiJson' in this.failedSiteIds ? (this.failedSiteIds as any).toApiJson() : this.failedSiteIds;}
      if (typeof this.status !== 'undefined') {toReturn['status'] = this.status;}
      if (typeof this.totalProcessed !== 'undefined') {toReturn['totalProcessed'] = this.totalProcessed;}
      if (typeof this.successCount !== 'undefined') {toReturn['successCount'] = this.successCount;}
      if (typeof this.failureCount !== 'undefined') {toReturn['failureCount'] = this.failureCount;}
      return toReturn;
  }
}

export class DeleteSitesResult implements i.DeleteSitesResultInterface {
  siteId: string;
  error: string;

  static fromProto(proto: any): DeleteSitesResult {
      let m = new DeleteSitesResult();
      m = Object.assign(m, proto);
      return m;
  }

  constructor(kwargs?: i.DeleteSitesResultInterface) {
      if (!kwargs) {
          return;
      }
      Object.assign(this, kwargs);
  }

  toApiJson(): object {
      const toReturn: {
          [key: string]: any;
      } = {};
      
      if (typeof this.siteId !== 'undefined') {toReturn['siteId'] = this.siteId;}
      if (typeof this.error !== 'undefined') {toReturn['error'] = this.error;}
      return toReturn;
  }
}

export class GetAppConfigRequest implements i.GetAppConfigRequestInterface {
  partnerId: string;

  static fromProto(proto: any): GetAppConfigRequest {
    let m = new GetAppConfigRequest();
    m = Object.assign(m, proto);
    return m;
  }

  constructor(kwargs?: i.GetAppConfigRequestInterface) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }

  toApiJson(): object {
    const toReturn: {
      [key: string]: any;
    } = {};

    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    return toReturn;
  }
}

export class GetAppConfigResponse implements i.GetAppConfigResponseInterface {
  config: AppConfig;

  static fromProto(proto: any): GetAppConfigResponse {
    let m = new GetAppConfigResponse();
    m = Object.assign(m, proto);
    if (proto.config) {
      m.config = AppConfig.fromProto(proto.config);
    }
    return m;
  }

  constructor(kwargs?: i.GetAppConfigResponseInterface) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }

  toApiJson(): object {
    const toReturn: {
      [key: string]: any;
    } = {};

    if (typeof this.config !== 'undefined' && this.config !== null) {
      toReturn['config'] = 'toApiJson' in this.config ? (this.config as any).toApiJson() : this.config;
    }
    return toReturn;
  }
}

export class GetHealthCheckRequest implements i.GetHealthCheckRequestInterface {
  siteId: string[];

  static fromProto(proto: any): GetHealthCheckRequest {
    let m = new GetHealthCheckRequest();
    m = Object.assign(m, proto);
    return m;
  }

  constructor(kwargs?: i.GetHealthCheckRequestInterface) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }

  toApiJson(): object {
    const toReturn: {
      [key: string]: any;
    } = {};

    if (typeof this.siteId !== 'undefined') {
      toReturn['siteId'] = this.siteId;
    }
    return toReturn;
  }
}

export class GetHealthCheckResponse implements i.GetHealthCheckResponseInterface {
  siteHealths: SiteHealths[];
  hasMore: boolean;
  totalResults: number;

  static fromProto(proto: any): GetHealthCheckResponse {
    let m = new GetHealthCheckResponse();
    m = Object.assign(m, proto);
    if (proto.siteHealths) {
      m.siteHealths = proto.siteHealths.map(SiteHealths.fromProto);
    }
    if (proto.totalResults) {
      m.totalResults = parseInt(proto.totalResults, 10);
    }
    return m;
  }

  constructor(kwargs?: i.GetHealthCheckResponseInterface) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }

  toApiJson(): object {
    const toReturn: {
      [key: string]: any;
    } = {};

    if (typeof this.siteHealths !== 'undefined' && this.siteHealths !== null) {
      toReturn['siteHealths'] =
        'toApiJson' in this.siteHealths ? (this.siteHealths as any).toApiJson() : this.siteHealths;
    }
    if (typeof this.hasMore !== 'undefined') {
      toReturn['hasMore'] = this.hasMore;
    }
    if (typeof this.totalResults !== 'undefined') {
      toReturn['totalResults'] = this.totalResults;
    }
    return toReturn;
  }
}

export class GetPluginUpdatesCountRequest implements i.GetPluginUpdatesCountRequestInterface {
  partnerId: string;

  static fromProto(proto: any): GetPluginUpdatesCountRequest {
    let m = new GetPluginUpdatesCountRequest();
    m = Object.assign(m, proto);
    return m;
  }

  constructor(kwargs?: i.GetPluginUpdatesCountRequestInterface) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }

  toApiJson(): object {
    const toReturn: {
      [key: string]: any;
    } = {};

    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    return toReturn;
  }
}

export class GetPluginUpdatesCountResponse implements i.GetPluginUpdatesCountResponseInterface {
  totalCount: number;

  static fromProto(proto: any): GetPluginUpdatesCountResponse {
    let m = new GetPluginUpdatesCountResponse();
    m = Object.assign(m, proto);
    if (proto.totalCount) {
      m.totalCount = parseInt(proto.totalCount, 10);
    }
    return m;
  }

  constructor(kwargs?: i.GetPluginUpdatesCountResponseInterface) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }

  toApiJson(): object {
    const toReturn: {
      [key: string]: any;
    } = {};

    if (typeof this.totalCount !== 'undefined') {
      toReturn['totalCount'] = this.totalCount;
    }
    return toReturn;
  }
}

export class HealthCheckValues implements i.HealthCheckValuesInterface {
  state: string;
  created: Date;
  updated: Date;

  static fromProto(proto: any): HealthCheckValues {
    let m = new HealthCheckValues();
    m = Object.assign(m, proto);
    if (proto.created) {
      m.created = new Date(proto.created);
    }
    if (proto.updated) {
      m.updated = new Date(proto.updated);
    }
    return m;
  }

  constructor(kwargs?: i.HealthCheckValuesInterface) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }

  toApiJson(): object {
    const toReturn: {
      [key: string]: any;
    } = {};

    if (typeof this.state !== 'undefined') {
      toReturn['state'] = this.state;
    }
    if (typeof this.created !== 'undefined' && this.created !== null) {
      toReturn['created'] = 'toApiJson' in this.created ? (this.created as any).toApiJson() : this.created;
    }
    if (typeof this.updated !== 'undefined' && this.updated !== null) {
      toReturn['updated'] = 'toApiJson' in this.updated ? (this.updated as any).toApiJson() : this.updated;
    }
    return toReturn;
  }
}

export class InitRepoRequest implements i.InitRepoRequestInterface {
  siteId: string;

  static fromProto(proto: any): InitRepoRequest {
    let m = new InitRepoRequest();
    m = Object.assign(m, proto);
    return m;
  }

  constructor(kwargs?: i.InitRepoRequestInterface) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }

  toApiJson(): object {
    const toReturn: {
      [key: string]: any;
    } = {};

    if (typeof this.siteId !== 'undefined') {
      toReturn['siteId'] = this.siteId;
    }
    return toReturn;
  }
}

export class InitRepoResponse implements i.InitRepoResponseInterface {
  siteSummary: SiteSummary;

  static fromProto(proto: any): InitRepoResponse {
    let m = new InitRepoResponse();
    m = Object.assign(m, proto);
    if (proto.siteSummary) {
      m.siteSummary = SiteSummary.fromProto(proto.siteSummary);
    }
    return m;
  }

  constructor(kwargs?: i.InitRepoResponseInterface) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }

  toApiJson(): object {
    const toReturn: {
      [key: string]: any;
    } = {};

    if (typeof this.siteSummary !== 'undefined' && this.siteSummary !== null) {
      toReturn['siteSummary'] =
        'toApiJson' in this.siteSummary ? (this.siteSummary as any).toApiJson() : this.siteSummary;
    }
    return toReturn;
  }
}

export class SearchPidHealthRequest implements i.SearchPidHealthRequestInterface {
  partnerId: string;

  static fromProto(proto: any): SearchPidHealthRequest {
    let m = new SearchPidHealthRequest();
    m = Object.assign(m, proto);
    return m;
  }

  constructor(kwargs?: i.SearchPidHealthRequestInterface) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }

  toApiJson(): object {
    const toReturn: {
      [key: string]: any;
    } = {};

    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    return toReturn;
  }
}

export class SearchPidHealthResponse implements i.SearchPidHealthResponseInterface {
  sites: SiteHealth[];
  totalResults: number;
  totalUpSites: number;
  totalDownSites: number;

  static fromProto(proto: any): SearchPidHealthResponse {
    let m = new SearchPidHealthResponse();
    m = Object.assign(m, proto);
    if (proto.sites) {
      m.sites = proto.sites.map(SiteHealth.fromProto);
    }
    if (proto.totalResults) {
      m.totalResults = parseInt(proto.totalResults, 10);
    }
    if (proto.totalUpSites) {
      m.totalUpSites = parseInt(proto.totalUpSites, 10);
    }
    if (proto.totalDownSites) {
      m.totalDownSites = parseInt(proto.totalDownSites, 10);
    }
    return m;
  }

  constructor(kwargs?: i.SearchPidHealthResponseInterface) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }

  toApiJson(): object {
    const toReturn: {
      [key: string]: any;
    } = {};

    if (typeof this.sites !== 'undefined' && this.sites !== null) {
      toReturn['sites'] = 'toApiJson' in this.sites ? (this.sites as any).toApiJson() : this.sites;
    }
    if (typeof this.totalResults !== 'undefined') {
      toReturn['totalResults'] = this.totalResults;
    }
    if (typeof this.totalUpSites !== 'undefined') {
      toReturn['totalUpSites'] = this.totalUpSites;
    }
    if (typeof this.totalDownSites !== 'undefined') {
      toReturn['totalDownSites'] = this.totalDownSites;
    }
    return toReturn;
  }
}

export class SearchRequest implements i.SearchRequestInterface {
  filters: SearchFilters;
  searchTerm: string;
  searchFields: e.SearchableField[];
  sortOptions: SortOptions;
  pageSize: number;
  from: number;

  static fromProto(proto: any): SearchRequest {
    let m = new SearchRequest();
    m = Object.assign(m, proto);
    if (proto.filters) {
      m.filters = SearchFilters.fromProto(proto.filters);
    }
    if (proto.searchFields) {
      m.searchFields = proto.searchFields.map((v: string) =>
        enumStringToValue<e.SearchableField>(e.SearchableField, v),
      );
    }
    if (proto.sortOptions) {
      m.sortOptions = SortOptions.fromProto(proto.sortOptions);
    }
    if (proto.pageSize) {
      m.pageSize = parseInt(proto.pageSize, 10);
    }
    if (proto.from) {
      m.from = parseInt(proto.from, 10);
    }
    return m;
  }

  constructor(kwargs?: i.SearchRequestInterface) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }

  toApiJson(): object {
    const toReturn: {
      [key: string]: any;
    } = {};

    if (typeof this.filters !== 'undefined' && this.filters !== null) {
      toReturn['filters'] = 'toApiJson' in this.filters ? (this.filters as any).toApiJson() : this.filters;
    }
    if (typeof this.searchTerm !== 'undefined') {
      toReturn['searchTerm'] = this.searchTerm;
    }
    if (typeof this.searchFields !== 'undefined') {
      toReturn['searchFields'] = this.searchFields;
    }
    if (typeof this.sortOptions !== 'undefined' && this.sortOptions !== null) {
      toReturn['sortOptions'] =
        'toApiJson' in this.sortOptions ? (this.sortOptions as any).toApiJson() : this.sortOptions;
    }
    if (typeof this.pageSize !== 'undefined') {
      toReturn['pageSize'] = this.pageSize;
    }
    if (typeof this.from !== 'undefined') {
      toReturn['from'] = this.from;
    }
    return toReturn;
  }
}

export class SearchResponse implements i.SearchResponseInterface {
  sites: WordPressSite[];
  hasMore: boolean;
  totalResults: number;

  static fromProto(proto: any): SearchResponse {
    let m = new SearchResponse();
    m = Object.assign(m, proto);
    if (proto.sites) {
      m.sites = proto.sites.map(WordPressSite.fromProto);
    }
    if (proto.totalResults) {
      m.totalResults = parseInt(proto.totalResults, 10);
    }
    return m;
  }

  constructor(kwargs?: i.SearchResponseInterface) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }

  toApiJson(): object {
    const toReturn: {
      [key: string]: any;
    } = {};

    if (typeof this.sites !== 'undefined' && this.sites !== null) {
      toReturn['sites'] = 'toApiJson' in this.sites ? (this.sites as any).toApiJson() : this.sites;
    }
    if (typeof this.hasMore !== 'undefined') {
      toReturn['hasMore'] = this.hasMore;
    }
    if (typeof this.totalResults !== 'undefined') {
      toReturn['totalResults'] = this.totalResults;
    }
    return toReturn;
  }
}

export class SetShowAdvancedFeaturesRequest implements i.SetShowAdvancedFeaturesRequestInterface {
  partnerId: string;
  showAdvancedFeatures: boolean;

  static fromProto(proto: any): SetShowAdvancedFeaturesRequest {
    let m = new SetShowAdvancedFeaturesRequest();
    m = Object.assign(m, proto);
    return m;
  }

  constructor(kwargs?: i.SetShowAdvancedFeaturesRequestInterface) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }

  toApiJson(): object {
    const toReturn: {
      [key: string]: any;
    } = {};

    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.showAdvancedFeatures !== 'undefined') {
      toReturn['showAdvancedFeatures'] = this.showAdvancedFeatures;
    }
    return toReturn;
  }
}

export class SetShowBackupsFeaturesRequest implements i.SetShowBackupsFeaturesRequestInterface {
  partnerId: string;
  showBackupFeatures: boolean;

  static fromProto(proto: any): SetShowBackupsFeaturesRequest {
      let m = new SetShowBackupsFeaturesRequest();
      m = Object.assign(m, proto);
      return m;
  }

  constructor(kwargs?: i.SetShowBackupsFeaturesRequestInterface) {
      if (!kwargs) {
          return;
      }
      Object.assign(this, kwargs);
  }

  toApiJson(): object {
      const toReturn: {
          [key: string]: any;
      } = {};
      
      if (typeof this.partnerId !== 'undefined') {toReturn['partnerId'] = this.partnerId;}
      if (typeof this.showBackupFeatures !== 'undefined') {toReturn['showBackupFeatures'] = this.showBackupFeatures;}
      return toReturn;
  }
}

export class SetShowDomainsFeaturesRequest implements i.SetShowDomainsFeaturesRequestInterface {
  partnerId: string;
  showDomainsFeatures: boolean;

  static fromProto(proto: any): SetShowDomainsFeaturesRequest {
      let m = new SetShowDomainsFeaturesRequest();
      m = Object.assign(m, proto);
      return m;
  }

  constructor(kwargs?: i.SetShowDomainsFeaturesRequestInterface) {
      if (!kwargs) {
          return;
      }
      Object.assign(this, kwargs);
  }

  toApiJson(): object {
      const toReturn: {
          [key: string]: any;
      } = {};
      
      if (typeof this.partnerId !== 'undefined') {toReturn['partnerId'] = this.partnerId;}
      if (typeof this.showDomainsFeatures !== 'undefined') {toReturn['showDomainsFeatures'] = this.showDomainsFeatures;}
      return toReturn;
  }
}

export class SetShowImportFeaturesRequest implements i.SetShowImportFeaturesRequestInterface {
  partnerId: string;
  showImportFeatures: boolean;

  static fromProto(proto: any): SetShowImportFeaturesRequest {
      let m = new SetShowImportFeaturesRequest();
      m = Object.assign(m, proto);
      return m;
  }

  constructor(kwargs?: i.SetShowImportFeaturesRequestInterface) {
      if (!kwargs) {
          return;
      }
      Object.assign(this, kwargs);
  }

  toApiJson(): object {
      const toReturn: {
          [key: string]: any;
      } = {};
      
      if (typeof this.partnerId !== 'undefined') {toReturn['partnerId'] = this.partnerId;}
      if (typeof this.showImportFeatures !== 'undefined') {toReturn['showImportFeatures'] = this.showImportFeatures;}
      return toReturn;
  }
}

export class SetShowIncludedTemplatesRequest implements i.SetShowIncludedTemplatesRequestInterface {
  partnerId: string;
  showIncludedTemplates: boolean;

  static fromProto(proto: any): SetShowIncludedTemplatesRequest {
    let m = new SetShowIncludedTemplatesRequest();
    m = Object.assign(m, proto);
    return m;
  }

  constructor(kwargs?: i.SetShowIncludedTemplatesRequestInterface) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }

  toApiJson(): object {
    const toReturn: {
      [key: string]: any;
    } = {};

    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.showIncludedTemplates !== 'undefined') {
      toReturn['showIncludedTemplates'] = this.showIncludedTemplates;
    }
    return toReturn;
  }
}

export class SetShowStagingFeaturesRequest implements i.SetShowStagingFeaturesRequestInterface {
  partnerId: string;
  showStagingFeatures: boolean;

  static fromProto(proto: any): SetShowStagingFeaturesRequest {
      let m = new SetShowStagingFeaturesRequest();
      m = Object.assign(m, proto);
      return m;
  }

  constructor(kwargs?: i.SetShowStagingFeaturesRequestInterface) {
      if (!kwargs) {
          return;
      }
      Object.assign(this, kwargs);
  }

  toApiJson(): object {
      const toReturn: {
          [key: string]: any;
      } = {};
      
      if (typeof this.partnerId !== 'undefined') {toReturn['partnerId'] = this.partnerId;}
      if (typeof this.showStagingFeatures !== 'undefined') {toReturn['showStagingFeatures'] = this.showStagingFeatures;}
      return toReturn;
  }
}

export class SiteHealth implements i.SiteHealthInterface {
  siteId: string;
  currentHealth: string;
  siteActivationStatus: boolean;

  static fromProto(proto: any): SiteHealth {
    let m = new SiteHealth();
    m = Object.assign(m, proto);
    return m;
  }

  constructor(kwargs?: i.SiteHealthInterface) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }

  toApiJson(): object {
    const toReturn: {
      [key: string]: any;
    } = {};

    if (typeof this.siteId !== 'undefined') {
      toReturn['siteId'] = this.siteId;
    }
    if (typeof this.currentHealth !== 'undefined') {
      toReturn['currentHealth'] = this.currentHealth;
    }
    if (typeof this.siteActivationStatus !== 'undefined') {
      toReturn['siteActivationStatus'] = this.siteActivationStatus;
    }
    return toReturn;
  }
}

export class SiteHealths implements i.SiteHealthsInterface {
  partnerId: string;
  siteId: string;
  accountId: string;
  primaryDomain: string;
  uptime1day: string;
  uptime7days: string;
  uptime30days: string;
  healthCheckValues: HealthCheckValues[];

  static fromProto(proto: any): SiteHealths {
    let m = new SiteHealths();
    m = Object.assign(m, proto);
    if (proto.healthCheckValues) {
      m.healthCheckValues = proto.healthCheckValues.map(HealthCheckValues.fromProto);
    }
    return m;
  }

  constructor(kwargs?: i.SiteHealthsInterface) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }

  toApiJson(): object {
    const toReturn: {
      [key: string]: any;
    } = {};

    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.siteId !== 'undefined') {
      toReturn['siteId'] = this.siteId;
    }
    if (typeof this.accountId !== 'undefined') {
      toReturn['accountId'] = this.accountId;
    }
    if (typeof this.primaryDomain !== 'undefined') {
      toReturn['primaryDomain'] = this.primaryDomain;
    }
    if (typeof this.uptime1day !== 'undefined') {
      toReturn['uptime1day'] = this.uptime1day;
    }
    if (typeof this.uptime7days !== 'undefined') {
      toReturn['uptime7days'] = this.uptime7days;
    }
    if (typeof this.uptime30days !== 'undefined') {
      toReturn['uptime30days'] = this.uptime30days;
    }
    if (typeof this.healthCheckValues !== 'undefined' && this.healthCheckValues !== null) {
      toReturn['healthCheckValues'] =
        'toApiJson' in this.healthCheckValues ? (this.healthCheckValues as any).toApiJson() : this.healthCheckValues;
    }
    return toReturn;
  }
}

export class UpdateCoreRequest implements i.UpdateCoreRequestInterface {
  siteId: string;
  coreCurrentVersion: string;
  coreLatestVersion: string;

  static fromProto(proto: any): UpdateCoreRequest {
    let m = new UpdateCoreRequest();
    m = Object.assign(m, proto);
    return m;
  }

  constructor(kwargs?: i.UpdateCoreRequestInterface) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }

  toApiJson(): object {
    const toReturn: {
      [key: string]: any;
    } = {};

    if (typeof this.siteId !== 'undefined') {
      toReturn['siteId'] = this.siteId;
    }
    if (typeof this.coreCurrentVersion !== 'undefined') {
      toReturn['coreCurrentVersion'] = this.coreCurrentVersion;
    }
    if (typeof this.coreLatestVersion !== 'undefined') {
      toReturn['coreLatestVersion'] = this.coreLatestVersion;
    }
    return toReturn;
  }
}

export class UpdatePluginsRequest implements i.UpdatePluginsRequestInterface {
  siteId: string;
  plugins: WordPressAddon[];
  method: string;

  static fromProto(proto: any): UpdatePluginsRequest {
    let m = new UpdatePluginsRequest();
    m = Object.assign(m, proto);
    if (proto.plugins) {
      m.plugins = proto.plugins.map(WordPressAddon.fromProto);
    }
    return m;
  }

  constructor(kwargs?: i.UpdatePluginsRequestInterface) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }

  toApiJson(): object {
    const toReturn: {
      [key: string]: any;
    } = {};

    if (typeof this.siteId !== 'undefined') {
      toReturn['siteId'] = this.siteId;
    }
    if (typeof this.plugins !== 'undefined' && this.plugins !== null) {
      toReturn['plugins'] = 'toApiJson' in this.plugins ? (this.plugins as any).toApiJson() : this.plugins;
    }
    if (typeof this.method !== 'undefined') {
      toReturn['method'] = this.method;
    }
    return toReturn;
  }
}

export class UpdateThemeRequest implements i.UpdateThemeRequestInterface {
  siteId: string;
  theme: WordPressAddon;

  static fromProto(proto: any): UpdateThemeRequest {
    let m = new UpdateThemeRequest();
    m = Object.assign(m, proto);
    if (proto.theme) {
      m.theme = WordPressAddon.fromProto(proto.theme);
    }
    return m;
  }

  constructor(kwargs?: i.UpdateThemeRequestInterface) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }

  toApiJson(): object {
    const toReturn: {
      [key: string]: any;
    } = {};

    if (typeof this.siteId !== 'undefined') {
      toReturn['siteId'] = this.siteId;
    }
    if (typeof this.theme !== 'undefined' && this.theme !== null) {
      toReturn['theme'] = 'toApiJson' in this.theme ? (this.theme as any).toApiJson() : this.theme;
    }
    return toReturn;
  }
}

export class GetMultiSiteRequest implements i.GetMultiSiteRequestInterface {
  siteIds: string[];

  static fromProto(proto: any): GetMultiSiteRequest {
    let m = new GetMultiSiteRequest();
    m = Object.assign(m, proto);
    return m;
  }

  constructor(kwargs?: i.GetMultiSiteRequestInterface) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }

  toApiJson(): object {
    const toReturn: {
      [key: string]: any;
    } = {};

    if (typeof this.siteIds !== 'undefined') {
      toReturn['siteIds'] = this.siteIds;
    }
    return toReturn;
  }
}

export class GetMultiSiteResponse implements i.GetMultiSiteResponseInterface {
  sites: WordPressSite[];

  static fromProto(proto: any): GetMultiSiteResponse {
    let m = new GetMultiSiteResponse();
    m = Object.assign(m, proto);
    if (proto.sites) {
      m.sites = proto.sites.map(WordPressSite.fromProto);
    }
    return m;
  }

  constructor(kwargs?: i.GetMultiSiteResponseInterface) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }

  toApiJson(): object {
    const toReturn: {
      [key: string]: any;
    } = {};

    if (typeof this.sites !== 'undefined' && this.sites !== null) {
      toReturn['sites'] = 'toApiJson' in this.sites ? (this.sites as any).toApiJson() : this.sites;
    }
    return toReturn;
  }
}

export class GetSiteRequest implements i.GetSiteRequestInterface {
  siteId: string;

  static fromProto(proto: any): GetSiteRequest {
    let m = new GetSiteRequest();
    m = Object.assign(m, proto);
    return m;
  }

  constructor(kwargs?: i.GetSiteRequestInterface) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }

  toApiJson(): object {
    const toReturn: {
      [key: string]: any;
    } = {};

    if (typeof this.siteId !== 'undefined') {
      toReturn['siteId'] = this.siteId;
    }
    return toReturn;
  }
}

export class GetSiteResponse implements i.GetSiteResponseInterface {
  site: WordPressSite;

  static fromProto(proto: any): GetSiteResponse {
    let m = new GetSiteResponse();
    m = Object.assign(m, proto);
    if (proto.site) {
      m.site = WordPressSite.fromProto(proto.site);
    }
    return m;
  }

  constructor(kwargs?: i.GetSiteResponseInterface) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }

  toApiJson(): object {
    const toReturn: {
      [key: string]: any;
    } = {};

    if (typeof this.site !== 'undefined' && this.site !== null) {
      toReturn['site'] = 'toApiJson' in this.site ? (this.site as any).toApiJson() : this.site;
    }
    return toReturn;
  }
}

export class GetDiscrepancyDataRequest implements i.GetDiscrepancyDataRequestInterface {
  environment: string;

  static fromProto(proto: any): GetDiscrepancyDataRequest {
    let m = new GetDiscrepancyDataRequest();
    m = Object.assign(m, proto);
    return m;
  }

  constructor(kwargs?: i.GetDiscrepancyDataRequestInterface) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }

  toApiJson(): object {
    const toReturn: {
      [key: string]: any;
    } = {};

    if (typeof this.environment !== 'undefined') {
      toReturn['environment'] = this.environment;
    }
    return toReturn;
  }
}

export class GetDiscrepancyDataResponse implements i.GetDiscrepancyDataResponseInterface {
  discrepancyData: string[];

  static fromProto(proto: any): GetDiscrepancyDataResponse {
    let m = new GetDiscrepancyDataResponse();
    m = Object.assign(m, proto);
    return m;
  }

  constructor(kwargs?: i.GetDiscrepancyDataResponseInterface) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }

  toApiJson(): object {
    const toReturn: {
      [key: string]: any;
    } = {};

    if (typeof this.discrepancyData !== 'undefined') {
      toReturn['discrepancyData'] = this.discrepancyData;
    }
    return toReturn;
  }
}
